import { Search } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { useHeaderFilters } from '../model/use-header-filters';

export function HeaderSearch() {
  const { searchConfig } = useHeaderFilters();

  if (!searchConfig?.enabled) return null;

  return (
    <div className="flex w-[360px] h-10 items-center gap-2 border-b border-border bg-transparent px-3 max-lg:w-full">
      <Search className="w-4 h-4 text-muted-foreground opacity-50" />
      <Input
        type="text"
        value={searchConfig.value}
        defaultValue={searchConfig.defaultValue}
        onChange={(e) => searchConfig.onChange(e.target.value)}
        placeholder={searchConfig.placeholder}
        className="flex-1 border-none shadow-none bg-transparent text-sm text-muted-foreground placeholder:text-muted-foreground focus-visible:ring-0"
        maxLength={200}
      />
    </div>
  );
}
